import React from "react"
import Header from "./../../Common/Layout/Header"
import Footer from "./../../Common/Layout/Footer"
import { Container, Image, Grid, Segment, Button, GridColumn } from "semantic-ui-react";
import logo_blue from "../../static/media/logo-xcm.svg";
import XCMTagLine from "../../static/media/XCMTagLine.5c1459fe.jpg";
function NotAuthorized() {
    var hostname = window.location.origin;
    return (
        <div>
            <Container>
                <Grid centered>
                    <Grid.Column width="12">
                        <Segment className="color-brd--dark-blue">
                            <Grid relaxed verticalAlign='middle'>
                                <Grid.Column floated='left' width={5}>
                                    <Image src={logo_blue} height={60} />
                                </Grid.Column>
                                <Grid.Column floated='right' width={5}>
                                    <Image src={XCMTagLine} />
                                </Grid.Column>
                            </Grid>
                            <Grid relaxed verticalAlign='middle' padded='very' textAlign='center' className="vh-min-80">
                                <Grid.Column >
                                    <p className="fs-20">You are not authorized to view this page... Try loging in <a target="_top" href={`${hostname}/xcmv2/account/login`}>here</a></p>

                                </Grid.Column>
                            </Grid>
                        </Segment>
                        <Segment className="border-top-10 color-brd--dark-blue" textAlign='center'>© {new Date().getFullYear()} Wolters Kluwer N.V. and/or its subsidiaries. All rights reserved.</Segment>
                    </Grid.Column>
                </Grid>
            </Container>
        </div>


    )
}

export default NotAuthorized